export const formatToCurrency = (amount, options = {}) => {
    if (!amount) return '$0'
    
    const locale = options.locale || 'en-US'
    const formatOptions = { style: 'currency', currency: 'USD', ...options }
    
    return new Intl.NumberFormat(locale, formatOptions).format(amount)
}

export const format = (amount, digits = 2) => {
    if (!amount) return 0
    const fixedAmount = amount % 1 === 0 ? amount : amount.toFixed(digits)
    return fixedAmount.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export const formatCurrency = (amount, digits) => {
    const formattedAbsolutePrice = format(Math.abs(amount), digits)
    const negationSymbol = amount < 0 ? '- ' : ''
    return `${negationSymbol}$${formattedAbsolutePrice}`
}
